var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "h-16 rounded-lg px-3 flex justify-between",
      class: [_vm.showButtons ? "border" : "bg-red-50"],
      staticStyle: { "border-color": "#E6EBEF" },
    },
    [
      _c(
        "div",
        {
          staticClass: "min-w-0 flex-1 flex justify-between items-center gap-4",
        },
        [
          _c(
            "button",
            {
              staticClass: "px-2 text-left",
              staticStyle: { color: "#4A5A69" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$emit("click", _vm.note)
                },
              },
            },
            [
              _c(
                "p",
                {
                  staticClass: "text-lg font-bold",
                  staticStyle: { color: "#2E3842", "line-height": "24px" },
                },
                [_vm._v(_vm._s(_vm.note.title))]
              ),
              _vm.showButtons
                ? _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        color: "#2E3842",
                        "line-height": "20px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formattedDuration(
                            _vm.note.startDate,
                            _vm.note.endDate
                          )
                        )
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          !_vm.showButtons
            ? _c("div", { staticClass: "pr-3 flex items-center gap-x-2" }, [
                _c(
                  "span",
                  { staticClass: "text-lg", staticStyle: { color: "#FF5353" } },
                  [_vm._v(_vm._s(_vm.meetingNoteDurationForm))]
                ),
                _c(
                  "button",
                  {
                    staticClass:
                      "h-9 text-white font-bold rounded-full px-6 flex items-center",
                    staticStyle: { "background-color": "#FF5353" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onClickMeetingNoteStop(_vm.note)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(this.$t("extendMenu.meetingNote.summary.stop"))
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm.showButtons
        ? _c("div", { staticClass: "flex items-center space-x-8" }, [
            _c("div", { staticClass: "space-x-8 flex items-center" }, [
              _vm.note.isSaving
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center gap-x-1 text-sm font-bold whitespace-nowrap",
                      staticStyle: { color: "#4A5A69" },
                    },
                    [
                      _vm._v(
                        _vm._s(this.$t("extendMenu.meetingNote.summary.saving"))
                      ),
                      _c("GrmLoadingCircle", { attrs: { size: "xs" } }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.note.summaryState === "notStarted"
                ? _c(
                    "button",
                    {
                      staticClass: "text-sm font-bold whitespace-nowrap",
                      staticStyle: { color: "#4A5A69" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onClickRequestSummary(_vm.note)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.$t("extendMenu.meetingNote.summary.create")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm.note.summaryState === "completed" ||
                  _vm.note.summaryState === "pending"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "flex items-center gap-x-1 text-sm font-bold whitespace-nowrap",
                      staticStyle: { color: "#4A5A69" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onClickSummaryDownload(_vm.note)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.$t("extendMenu.meetingNote.summary.title")
                          ) +
                          " "
                      ),
                      _vm.note.summaryState === "completed"
                        ? _c("img", {
                            staticClass: "pointer-events-none",
                            attrs: {
                              width: "22",
                              height: "22",
                              src: require("@/assets/images/meeting-note/download_gray.svg"),
                            },
                          })
                        : _vm._e(),
                      _vm.note.summaryState === "pending"
                        ? _c("GrmLoadingCircle", { attrs: { size: "xs" } })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm.note.summaryState === "failed"
                ? _c(
                    "button",
                    {
                      staticClass: "text-red-400",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onClickFailedSummary(_vm.note)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.$t("extendMenu.meetingNote.summary.fail")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c(
              "button",
              {
                staticClass: "ai-item-more-toggle-button",
                on: { click: _vm.onToggleIsOpenList },
              },
              [
                _c("img", {
                  staticClass: "pointer-events-none",
                  attrs: {
                    width: "16",
                    height: "16",
                    src: require("@/assets/images/more.svg"),
                  },
                }),
              ]
            ),
            _c("div", { staticClass: "ai-item-more-button" }, [
              _c(
                "div",
                { staticClass: "absolute top-3/4 right-0" },
                [
                  _c("GrmMenu", {
                    attrs: { list: _vm.aiMoreList, open: _vm.isOpenList },
                    on: {
                      "update:open": function ($event) {
                        _vm.isOpenList = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }